import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ActivepopupPage } from './activepopup';

@NgModule({
  declarations: [
    ActivepopupPage,
  ],
  imports: [
    IonicPageModule.forChild(ActivepopupPage),
  ],
})
export class ActivepopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/activepopup/activepopup.module.ts